import { render } from "./SelectWithholdingAgent.vue?vue&type=template&id=3f44736d"
import script from "./SelectWithholdingAgent.vue?vue&type=script&lang=js"
export * from "./SelectWithholdingAgent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__